var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunthar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 122,
    viewBox: "0 0 126 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_72_13",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 126,
    height: 122
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2839 88.4297L5.00685 119.946C4.57152 120.955 3.77214 121.457 2.61199 121.457C1.88444 121.457 1.26845 121.208 0.762373 120.702C0.251948 120.199 0 119.589 0 118.867C0 118.436 0.0712854 118.078 0.21821 117.788L44.4038 12.8763C45.9993 8.99126 48.4649 6.04306 51.8049 4.02633L52.2397 3.5946C55.4302 1.72573 58.9128 0.78833 62.6882 0.78833C66.7488 0.78833 70.4491 1.86766 73.7886 4.02633L74.0063 4.24166H74.2245C77.2713 6.40032 79.591 9.28106 81.1898 12.8763L125.376 117.788V118.651C125.376 120.523 124.505 121.457 122.763 121.457C121.458 121.457 120.73 120.955 120.587 119.946L107.31 88.4297H18.2839Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_72_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.375 0.78833H62.4736V121.457H125.375V0.78833Z",
    fill: "#FF005D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_72_13",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 126,
    height: 122
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2839 88.4297L5.00685 119.946C4.57152 120.955 3.77214 121.457 2.61199 121.457C1.88444 121.457 1.26845 121.208 0.762373 120.702C0.251948 120.199 0 119.589 0 118.867C0 118.436 0.0712854 118.078 0.21821 117.788L44.4038 12.8763C45.9993 8.99126 48.4649 6.04306 51.8049 4.02633L52.2397 3.5946C55.4302 1.72573 58.9128 0.78833 62.6882 0.78833C66.7488 0.78833 70.4491 1.86766 73.7886 4.02633L74.0063 4.24166H74.2245C77.2713 6.40032 79.591 9.28106 81.1898 12.8763L125.376 117.788V118.651C125.376 120.523 124.505 121.457 122.763 121.457C121.458 121.457 120.73 120.955 120.587 119.946L107.31 88.4297H18.2839Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_72_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.856209 0.78833H62.9015V121.457H-0.856209V0.78833Z",
    fill: "#BDEA88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunthar);
export default __webpack_public_path__ + "static/media/sunthar.1b6ea6dfd2279571bbc6761e44275019.svg";
export { ForwardRef as ReactComponent };